export default __webpack_public_path__ + "static/media/ALETA_PLANET.9d53b9b5.png";